import { COUNTRY } from '@/config';

import sliderL1 from '@/media/factoryAgent/slider/br-images/slider-l1.webp';
import sliderL1Mid from '@/media/factoryAgent/slider/br-images/slider-l1-768.webp';
import sliderL1Small from '@/media/factoryAgent/slider/br-images/slider-l1-360.webp';
import sliderL2 from '@/media/factoryAgent/slider/br-images/slider-l2.webp';
import sliderL2Mid from '@/media/factoryAgent/slider/br-images/slider-l2-768.webp';
import sliderL2Small from '@/media/factoryAgent/slider/br-images/slider-l2-360.webp';
import sliderL3 from '@/media/factoryAgent/slider/br-images/slider-l3.webp';
import sliderL3Mid from '@/media/factoryAgent/slider/br-images/slider-l3-768.webp';
import sliderL3Small from '@/media/factoryAgent/slider/br-images/slider-l3-360.webp';
import sliderL4 from '@/media/factoryAgent/slider/br-images/slider-l4.webp';
import sliderL4Mid from '@/media/factoryAgent/slider/br-images/slider-l4-768.webp';
import sliderL4Small from '@/media/factoryAgent/slider/br-images/slider-l4-360.webp';
import sliderL5 from '@/media/factoryAgent/slider/br-images/slider-l5.webp';
import sliderL5Mid from '@/media/factoryAgent/slider/br-images/slider-l5-768.webp';
import sliderL5Small from '@/media/factoryAgent/slider/br-images/slider-l5-360.webp';
import sliderL6 from '@/media/factoryAgent/slider/br-images/slider-l6.webp';
import sliderL6Mid from '@/media/factoryAgent/slider/br-images/slider-l6-768.webp';
import sliderL6Small from '@/media/factoryAgent/slider/br-images/slider-l6-360.webp';

import sliderL1ES from '@/media/factoryAgent/slider/es-images/slider-l1.webp';
import sliderL1MidES from '@/media/factoryAgent/slider/es-images/slider-l1-768.webp';
import sliderL1SmallES from '@/media/factoryAgent/slider/es-images/slider-l1-360.webp';
import sliderL2ES from '@/media/factoryAgent/slider/es-images/slider-l2.webp';
import sliderL2MidES from '@/media/factoryAgent/slider/es-images/slider-l2-768.webp';
import sliderL2SmallES from '@/media/factoryAgent/slider/es-images/slider-l2-360.webp';
import sliderL3ES from '@/media/factoryAgent/slider/es-images/slider-l3.webp';
import sliderL3MidES from '@/media/factoryAgent/slider/es-images/slider-l3-768.webp';
import sliderL3SmallES from '@/media/factoryAgent/slider/es-images/slider-l3-360.webp';
import sliderL4ES from '@/media/factoryAgent/slider/es-images/slider-l4.webp';
import sliderL4MidES from '@/media/factoryAgent/slider/es-images/slider-l4-768.webp';
import sliderL4SmallES from '@/media/factoryAgent/slider/es-images/slider-l4-360.webp';
import sliderL5ES from '@/media/factoryAgent/slider/es-images/slider-l5.webp';
import sliderL5MidES from '@/media/factoryAgent/slider/es-images/slider-l5-768.webp';
import sliderL5SmallES from '@/media/factoryAgent/slider/es-images/slider-l5-360.webp';
import sliderL6ES from '@/media/factoryAgent/slider/es-images/slider-l6.webp';
import sliderL6MidES from '@/media/factoryAgent/slider/es-images/slider-l6-768.webp';
import sliderL6SmallES from '@/media/factoryAgent/slider/es-images/slider-l6-360.webp';

const isBr = COUNTRY === 'br';

export const sliderImagesContent = {
  imagesSliderLeft: [
    {
      alt: 'slide left image first',
      src: isBr ? sliderL1 : sliderL1ES,
      midSrc: isBr ? sliderL1Mid : sliderL1MidES,
      smallSrc: isBr ? sliderL1Small : sliderL1SmallES,
      width: 580,
      midWidth: 300,
      smallWidth: 225,
    },
    {
      alt: 'slide left image second',
      src: isBr ? sliderL2 : sliderL2ES,
      midSrc: isBr ? sliderL2Mid : sliderL2MidES,
      smallSrc: isBr ? sliderL2Small : sliderL2SmallES,
      width: 580,
      midWidth: 300,
      smallWidth: 225,
    },
    {
      alt: 'slide left image third',
      src: isBr ? sliderL3 : sliderL3ES,
      midSrc: isBr ? sliderL3Mid : sliderL3MidES,
      smallSrc: isBr ? sliderL3Small : sliderL3SmallES,
      width: 225,
      midWidth: 115,
      smallWidth: 87,
    },
    {
      alt: 'slide left image fourth',
      src: isBr ? sliderL4 : sliderL4ES,
      midSrc: isBr ? sliderL4Mid : sliderL4MidES,
      smallSrc: isBr ? sliderL4Small : sliderL4SmallES,
      width: 580,
      midWidth: 300,
      smallWidth: 225,
    },
    {
      alt: 'slide left image fifth',
      src: isBr ? sliderL5 : sliderL5ES,
      midSrc: isBr ? sliderL5Mid : sliderL5MidES,
      smallSrc: isBr ? sliderL5Small : sliderL5SmallES,
      width: 225,
      midWidth: 115,
      smallWidth: 87,
    },
    {
      alt: 'slide left image sixth',
      src: isBr ? sliderL6 : sliderL6ES,
      midSrc: isBr ? sliderL6Mid : sliderL6MidES,
      smallSrc: isBr ? sliderL6Small : sliderL6SmallES,
      width: 580,
      midWidth: 300,
      smallWidth: 225,
    },
  ],
};
